import { useTheme } from '@/hooks/useTheme'
import moonIcon from '@/assets/header/moon.svg'

export const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme()

  return (
    <button
      onClick={toggleTheme}
      className="p-0 w-full h-full flex items-center justify-center transition-colors"
      aria-label={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
    >
      <img src={moonIcon} alt="Theme toggle" className="w-4 h-4" />
    </button>
  )
}

export default ThemeToggle 